import { Eye } from 'lucide-react'
import { type ReactNode, useState } from 'react'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/shared/ui/dialog'

interface PreviewModalProps {
  title: string
  description: string
  onFieldClick?: (fieldName: string) => void
  children: (onFieldClick: (fieldName: string) => void) => ReactNode
}

export function PreviewModal({ title, description, onFieldClick, children }: PreviewModalProps) {
  const [open, setOpen] = useState(false)

  const handleFieldClick = (fieldName: string) => {
    setOpen(false)
    setTimeout(() => {
      onFieldClick?.(fieldName)
    }, 100)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="gap-2">
          <Eye className="w-4 h-4" />
          {m.preview()}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="mt-4">{children(handleFieldClick)}</div>
      </DialogContent>
    </Dialog>
  )
}
